<template>
  <md-toolbar class="toolbar md-primary old-globals">
    <h3 class="md-title">
      {{ title }}
      <slot name="title" />
    </h3>
    <div class="checkbox">
      <slot name="checkbox" />
    </div>
    <slot />
    <div class="search">
      <md-icon v-if="hasSearch">search</md-icon>
      <md-field v-if="hasSearch">
        <md-input :placeholder="searchPlaceholder" :value="state.searchTerm" @input="search" />
      </md-field>
    </div>
    <slot name="search" />
    <md-button v-if="hasMenu" class="md-icon-button md-dense">
      <md-icon>more_vert</md-icon>
    </md-button>
  </md-toolbar>
</template>

<script>
export default {
  name: 'toolbar',
  props: {
    title: {
      type: String,
      default: '',
    },
    hasSearch: {
      type: Boolean,
      default: true,
    },
    searchPlaceholder: {
      type: String,
      default: 'Search',
    },
    hasMenu: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      state: {
        searchTerm: '',
      },
    };
  },
  methods: {
    search(term) {
      this.state.searchTerm = term;
      this.$emit('search', term);
    },
  },
};
</script>

<style scoped>
.md-title {
  flex: 1;
}

.md-input {
  border-radius: 0;
}
</style>

<style>
.search {
  display: flex;
  flex-direction: row;
}

.search .md-field {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 0;
}

.search .md-input {
  background-color: #fafafa !important;
  color: rgba(0, 0, 0, 0.54) !important;
  -webkit-text-fill-color: rgba(0, 0, 0, 0.54) !important;
  height: 40px;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  font-size: 18px !important;
}
.search .md-input::placeholder {
  font-size: 18px;
}

.search .md-icon {
  background-color: #fafafa;
  color: rgba(0, 0, 0, 0.54) !important;
  width: auto !important;
  height: 40px;
  padding-left: 16px;
  padding-right: 14px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.checkbox {
  display: flex;
}
</style>